import tw from 'tailwind-styled-components'
import {DivWithHint} from '@components/common/hint/hint'

export const TwLabelContainer = tw(DivWithHint)`
  cursor-pointer
  min-w-0
  flex-auto
  shrink-[2]
  flex
  gap-2
  mr-4
  last:mr-0
  group/label
`

// `pt-1` to align w/ username
export const TwLabel = tw.div`
  pt-1
  inline-block
  flex-initial
  text-secondary
  group-hover/label:text-action-default
  text-11
  leading-4
  whitespace-nowrap
  overflow-hidden
  text-ellipsis
`

export const TwLabelInput = tw.input`
  all-unset
  pt-1
  flex-auto
  whitespace-nowrap
  overflow-hidden
  text-clip
  cursor-text
  h-16
  flex
  items-center
  shadow-border-b-1
  shadow-grey-l60
  text-primary
  text-11
  leading-4
`
